var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgSymmetry = function SvgSymmetry(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M13.7 19h6.197a.7.7 0 0 0 .633-.998L14.333 4.833c-.318-.676-1.333-.45-1.333.298V18.3a.7.7 0 0 0 .7.7ZM10.3 19H4.103a.7.7 0 0 1-.633-.998L9.667 4.833c.318-.676 1.333-.45 1.333.298V18.3a.7.7 0 0 1-.7.7Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSymmetry);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;